import { useEffect } from "react";
import "@/App.css";
import Lenis from "@studio-freight/lenis";
import Landing from "@/components/Landing";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);

    const handleAnchor = (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;
      const id = link.getAttribute("href");
      if (id.length > 1) {
        e.preventDefault();
        const el = document.querySelector(id);
        if (el) lenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", handleAnchor);

    return () => {
      cancelAnimationFrame(id);
      document.removeEventListener("click", handleAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <Landing />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
